import { __rest } from "tslib";
import React from 'react';
import { Handle, Position } from 'reactflow';
const getPositionStyle = (position) => {
    if (position === Position.Left) {
        return {
            left: 0,
            transform: `translateX(-50%)`,
        };
    }
    else if (position === Position.Right) {
        return {
            left: 0,
            transform: `translateX(50%)`,
        };
    }
    else if (position === Position.Top) {
        return {
            top: 0,
            transform: `translateY(-50%)`,
        };
    }
    else if (position === Position.Bottom) {
        return {
            bottom: 0,
            transform: `translateY(50%)`,
        };
    }
};
const CircleHandle = props => {
    const { style = {}, position } = props, rest = __rest(props, ["style", "position"]);
    const positonStyle = getPositionStyle(position);
    return (React.createElement(Handle, Object.assign({}, rest, { position: position, style: Object.assign(Object.assign(Object.assign({}, positonStyle), style), { width: 6, height: 6, borderRadius: '50%', background: '#fff', border: '1px solid #c8c8c8' }) })));
};
export default CircleHandle;
//# sourceMappingURL=index.js.map